<template>
  <div
      :data-product-id="productId"
      :class="{
      _gift: isGift,
      _unavailable: isBasket && !isAvailable,
      '_last-unavailable': isLastUnavailable
    }"
      class="basket-product-item-m"
  >
    <div class="basket-product-item-m__main-holder">
      <div class="basket-product-item-m__picture-holder">
        <app-link
          class="basket-product-item-m__image-link"
          :href="productLink"
          blank
        >
          <app-picture
            class-picture="basket-product-item-m__picture"
            :alt="`Купить ${productName} — Фото №1`"
            class-img="basket-product-item-m__image"
            :fallback-image="productImageFallback"
            :item="productPicture"
          />
        </app-link>
      </div>

      <div class="basket-product-item-m__body-holder">
        <div class="basket-product-item-m__name">
          <app-link
            class="basket-product-item-m__name-link"
            target="_blank"
            :href="productLink"
          >
            {{ productName }}
          </app-link>
        </div>
        <author-list
          class="basket-product-item-m__author-list"
          :author-list="authorListFormatted"
        />
        <prices-block
          class="basket-product-item-m__prices-block"
          :quantity-in-basket="quantityInBasket"
          :amount="amount"
          :is-gift="isGift"
        />
        <item-controls
          class="basket-product-item-m__item-controls"
          :product-id="productId"
          :category-id="categoryId"
          :amount="amount"
          :buy-only-pre-paid-info-text="buyOnlyPrePaidInfoText"
          :cnt-info-text="cntInfoText"
          :is-gift="isGift"
          :max-count="maxCount"
          :quantity-in-basket="quantityInBasket"
          :show-counter="showCounter"
          :show-change-gift="showChangeGift"
          :product-link="productLink"
          :is-loading-add-to-basket="isLoadingAddToBasket"
          :is-certificate="isCertificate"
          :is-pre-order="isPreOrder"
          :is-available="isAvailable"
          :is-basket="isBasket"
          @changeCount="handlerChangeCount"
          @openAuthModal="handlerClickAuth"
          @moveToWishList="handlerMoveToWishList"
          @removeItem="handlerRemoveItem"
          @clickChangeGift="handlerClickChangeGift"
          @addToBasketItem="handlerAddToBasketItem"
          @changeTab="handlerChangeTab"
          @clickNotAvailable="handlerClickNotAvailable"
        />
      </div>
    </div>
    <information-list
      v-if="!isGift"
      class="basket-product-item-m__information-list"
      :is-promo-disabled="isPromoDisabled"
      :is-purchased="isPurchased"
      @openAuthModal="handlerClickAuth"
    />
    <moved-or-deleted-info
      v-if="isDeleted || isMoved"
      :class="{ _gift: isGift }"
      :is-moved="isMoved"
      :is-deleted="isDeleted"
      :product-name="productName"
      :product-link="productLink"
      @spliceItem="handlerSpliceItem"
      @restoreItem="handlerRestoreItem"
    />
    <loader-block v-if="isLoading" class="basket-product-item-m__loader" text="" />
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api';
import { LoaderBlock } from '@book24/ui-components';

import useProductItem from '@/compositions/useProductItem';

import AppPicture from '@/components/AppPicture/index.vue';
import AuthorList from '@/components/ProductCard/AuthorList/index.vue';
import InformationList from '@/components/_mobile/ProductItem/InformationList/index.vue';
import PricesBlock from '@/components/_mobile/ProductItem/PricesBlock/index.vue';
import ItemControls from '@/components/_mobile/ProductItem/ItemControls/index.vue';
import MovedOrDeletedInfo from '@/components/_mobile/ProductItem/MovedOrDeletedInfo/index.vue';

export default defineComponent({
  name: 'ProductItem',
  components: {
    LoaderBlock,
    AppPicture,
    AuthorList,
    InformationList,
    PricesBlock,
    ItemControls,
    MovedOrDeletedInfo,
  },
  props: {
    basketItemId: { type: [String, Number], required: true },
    productId: { type: [String, Number], required: true },
    productName: { type: String, required: true },
    productCode: { type: String, required: true },
    categoryId: { type: [Number, String], required: true },
    amount: { type: Object, default: () => ({ discounted: 0, total: 0 }) },
    picture: { type: Object, default: () => ({}) },
    quantityInBasket: { type: Number, default: 1 },
    quantityAvailable: { type: Number, default: 1 },
    isMoved: { type: Boolean, default: false },
    isDeleted: { type: Boolean, default: false },
    isGift: { type: Boolean, default: false },
    isPreOrder: { type: Boolean, default: false },
    isAvailable: { type: Boolean, default: true },
    isPromoDisabled: { type: Boolean, default: false },
    isBuyOnlyPrePaid: { type: Boolean, default: false },
    isCertificate: { type: Boolean, default: false },
    authorList: { type: Array, default: () => ([]) },
    isLoading: { type: Boolean, default: false },
    isBasket: { type: Boolean, default: true },
    isLoadingAddToBasket: { type: Boolean, default: false },
    showChangeGift: { type: Boolean, default: false },
    isPurchased: { type: Boolean, default: false },
    link: { type: String, default: '' },
    isLastUnavailable: { type: Boolean, default: false },
  },
  setup(props) {
    const productItem = useProductItem(props);

    return {
      ...productItem,
    };
  },
});
</script>

<style lang="less">
.basket-product-item-m {
  padding: @size-x4;
  position: relative;
  display: block;

  &._unavailable {
    background: @yellow-back;
    border-bottom: none;

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      width: calc(100% - @size-x8);
      height: 1px;
      background: @gray-super-light;
    }

    &._last-unavailable {
      margin-bottom: @size-x3;

      &::after {
        display: none;
      }
    }
  }

  &._gift {
    background-color: @yellow-back;
  }

  &__main-holder {
    display: flex;
  }

  &__picture-holder {
    flex: 0 0 60px;
    margin-right: @size-x4;
  }

  &__image-link {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    text-align: center;
  }

  &__picture {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
  }

  &__image {
    width: 100%;
    max-width: 100%;
    max-height: 100%;
    object-fit: cover;
  }

  &__body-holder {
    flex: 1 1 auto;
  }

  &__name-link {
    .a-reset();
    .p();

    color: @black;
    transition: @A color;
    word-break: break-word;

    a&:hover {
      color: lighten(@gray, 12%);
    }

    a&._tap {
      color: darken(@gray, 12%);
    }
  }

  &__prices-block {
    margin-top: @main-size;
  }

  &__information-list {
    margin-top: @size-x4;
  }

  &__item-controls {
    margin-top: @main-size;
  }

  &__loader {
    z-index: 2;
  }
}
</style>
